import { defineMessages } from 'react-intl';

export type BlogSport = 'football' | 'nba' | 'mlb';

export const supportedLanguages = new Set(['fr', 'it', 'de', 'es', 'en']);

export const categories = defineMessages({
  news: {
    id: 'blog.categories.news',
    defaultMessage: 'News',
  },
  'fantasy-meets-reality': {
    id: 'blog.categories.fantasyMeetsReality',
    defaultMessage: 'Fantasy Meets Reality',
  },
  'get-started': {
    id: 'blog.categories.getStarted',
    defaultMessage: 'Get Started',
  },
});

export const DEFAULT_POST_PICTURE =
  'https://frontend-assets.sorare.com/meta/social-picture-2022.png';
